
const RU_NATIONAL = 10;

const E164_MAX = 15;

const RU_PREFIXES = ['7', '8'];

export function maskPhone(input: string): string {
  const international = input.trimStart().startsWith('+');
  const digits = input.replace(/\D/g, '');

  if (digits.length === 0) return international ? '+' : '';
  if (international && !RU_PREFIXES.includes(digits[0])) {
    return `+${digits.slice(0, E164_MAX)}`;
  }

  const national = (
    RU_PREFIXES.includes(digits[0]) ? digits.slice(1) : digits
  ).slice(0, RU_NATIONAL);

  let out = `+7 (${national.slice(0, 3)}`;
  if (national.length >= 3) out += ')';
  if (national.length > 3) out += ` ${national.slice(3, 6)}`;
  if (national.length > 6) out += `-${national.slice(6, 8)}`;
  if (national.length > 8) out += `-${national.slice(8, 10)}`;
  return out;
}

export function maskPhoneEdit(next: string, previous: string): string {
  if (next.length >= previous.length) return maskPhone(next);
  const trimmed = maskPhone(next) === previous ? next.replace(/\d(?!.*\d)/, '') : next;
  return /\d/.test(trimmed) ? maskPhone(trimmed) : '';
}
